var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99844 19L5.49844 18.5C5.19844 18.2 5.19844 17.7 5.49844 17.3L17.9984 5L18.4984 5.5C18.7984 5.8 18.7984 6.3 18.4984 6.7L5.99844 19Z",
    fill: "#4d4d4d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9985 19L5.59848 6.6C5.29848 6.3 5.29848 5.8 5.59848 5.4L5.99848 5L18.3985 17.4C18.6985 17.7 18.6985 18.2 18.3985 18.6L17.9985 19Z",
    fill: "#4d4d4d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8aa92a1123d5b0d26d98301c6b6e847f.svg";
export { ForwardRef as ReactComponent };